module.exports = __webpack_public_path__ + "static/media/floorplay_icon.44c82238.svg";